<template>
  <div class="books-wrapper">
    <div
      v-for="book in books"
      :key="book"
      class="button-container"
    >
      <GenericButton
        class="image-btn"
        :title="book.title"
        :disabled="book.disabled"
        @click="readBook(book.key)"
        :image-src="book.imageSrc"
        :is-active="book.read"
        width="55px"
        height="30px"
        image-width="30px"
      />
    </div>
  </div>
</template>
<script>
import { useStore } from "vuex";
import GenericButton from "../shared/GenericButton.vue";
import { computed } from "vue";
export default {
    name: "Books",
    setup() {
        const store = useStore();
        const getBookImage = (book) => {
          return require(`@/assets/img/books/${book}Book.png`);
        };
        const books = computed(() => {
          return Object.keys(store.state.build.Books)
          .reduce((acc, curr) => {
            const available = store.state.build.Books[curr].available;
            const bookName = store.state.build.Books[curr].name;
            const readBooks = store.state.build.Books[curr].read;
            const gainedSkill = store.state.build.Books[curr].gainedSkillValue;
            const title = readBooks ? `${readBooks} ${bookName} books read (${bookName} skill +${gainedSkill}%)` : `Read 10 ${bookName} books`;

            acc.push({
              key: curr,
              read: !!readBooks,
              title,
              available, 
              disabled: !available,
              imageSrc: getBookImage(curr)
            })
            return acc;
          }, [])});

        const readBook = (book) => {
            const data = {
                skill: book,
                modifier: "book",
                multiplier: 10,
            };
            store.dispatch('handleIncomingCommand', {
                command: 'selectSkill',
                data: book
            });
            store.dispatch('handleIncomingCommand', {
                command: 'modifySkill',
                data: data
            });
        };
        return {
            state: store.state,
            books,
            readBook,
            getBookImage
        };
    },
    components: { GenericButton }
};
</script>
<style scoped>
.books-wrapper {
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
  width: 100%;
  row-gap: 2px;
  margin-top: 4px;
}
.button-container {
  position: relative;
}
.image-btn {
  position: relative;
  display: flex;
  justify-content: space-between;
}
.image-btn:focus {
  outline: none;
  box-shadow: none;
}
</style>